import {
  LOADING_BANNER,
  HEROS_BANNER,
  LOADING_FEAUTURED_BANNER,
  FEAUTURED_BANNER,
  LOADING_COMMERCIAL_BANNER,
  COMMERCIAL_BANNER,
  LOADING_PARTNER_BANNER,
  PARTNER_BANNER,
  BANNER_ONE_LIST,
  BANNER_TWO_LIST
} from '../types/types'

const initialState = {
  herosBanner: [],
  feauturedBanner: [],
  commercialBanner: [],
  partnerBanner: [],
  loading: false,
  bannerOneList: {},
  bannerTwoList: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LOADING_BANNER:
      return { ...state, loading: action.payload || false };
    case LOADING_FEAUTURED_BANNER:
      return { ...state, loading: action.payload || false };
    case LOADING_COMMERCIAL_BANNER:
      return { ...state, loading: action.payload || false };
    case LOADING_PARTNER_BANNER:
      return { ...state, loading: action.payload || false };
    case HEROS_BANNER:
      return { ...state, herosBanner: action.payload };
    case FEAUTURED_BANNER:
      return { ...state, feauturedBanner: action.payload };
    case COMMERCIAL_BANNER:
      return { ...state, commercialBanner: action.payload };
    case PARTNER_BANNER:
      return { ...state, partnerBanner: action.payload };

    case BANNER_ONE_LIST:
      return { ...state, bannerOneList: action.payload };
    case BANNER_TWO_LIST:
      return { ...state, bannerTwoList: action.payload };

    default:
      return state;
  }
}
